import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "user",
  class: "form-label"
}, "Usuario: *", -1)
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "zona",
  class: "form-label"
}, "Perfil: *", -1)
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "pass1",
  class: "form-label"
}, "Contraseña: *", -1)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "pass2",
  class: "form-label"
}, "Confirmar Contraseña: *", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "form-label"
}, "Nombre: *", -1)
const _hoisted_17 = { class: "row mt-5" }
const _hoisted_18 = { class: "col-md-12 text-center" }

export function render(_ctx, _cache) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("form", {
    autocomplete: "off",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers((...args) => (_ctx.registerUser && _ctx.registerUser(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            id: "user",
            autocomplete: "off",
            type: "text",
            class: "form-control",
            placeholder: "Nombre",
            modelValue: _ctx.newUser.user,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.newUser.user) = $event)),
            requiered: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Dropdown, {
            id: "zona",
            class: "vue-input",
            options: _ctx.zonas,
            optionLabel: "valor",
            name: "select1",
            optionValue: "id",
            placeholder: "Seleccionar...",
            modelValue: _ctx.newUser.perfil,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.newUser.perfil) = $event)),
            requiered: ""
          }, null, 8, ["options", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_InputText, {
            id: "pass1",
            autocomplete: "new-password",
            name: "hidden",
            type: "password",
            class: "form-control",
            placeholder: "Escriba su contreña",
            modelValue: _ctx.newUser.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.newUser.password) = $event)),
            min: "6",
            requiered: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_InputText, {
            id: "pass2",
            type: "password",
            class: "form-control",
            placeholder: "Confirme la contraseña",
            modelValue: _ctx.confpw,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.confpw) = $event)),
            min: "6",
            requiered: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_InputText, {
            id: "username",
            autocomplete: "false",
            type: "text",
            class: "form-control",
            placeholder: "Nombre",
            modelValue: _ctx.newUser.nombre,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.newUser.nombre) = $event)),
            requiered: ""
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_Button, {
          type: "submit",
          label: "Registrar",
          severity: "success",
          loading: _ctx.loader,
          icon: "pi pi-check"
        }, null, 8, ["loading"])
      ])
    ])
  ], 32))
}